
export abstract class TypedJsonAny {
  public static readonly OPTIONS: object = {
    deserializer(val: any): any {
      return val;
    }
  };
}
